import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, change as changeFieldValue } from "redux-form";
import Recaptcha from "react-recaptcha";
import config from "config";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import validationUtils from "../../utils/ValidationUtils";
import { MEMBER_IDENTIFIER_RECOVERY_VALIDATION_RULES } from "./memberIdentifierRecoveryValidationRules";

import { DayPicker, StyledCheckboxInput, TextInput } from "../common/form";
import { BSModal, MessageBox } from "../common";

class MemberIdentifierRecoveryForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSuccessModal: true,
    };

    this.closeSuccessModal = this.closeSuccessModal.bind(this);
    this.renderSubmitMessage = this.renderSubmitMessage.bind(this);
    this.updateCaptcha = this.updateCaptcha.bind(this);
  }

  componentWillMount() {
    this.updateCaptcha();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.hasSubmitError !== this.props.hasSubmitError &&
      this.props.hasSubmitError === true
    ) {
      this.recaptchaRef.reset();
      setTimeout(() => this.updateCaptcha(), 1000);
    }
  }

  renderSubmitMessage() {
    const { hasSubmitError, memberIdentifier, submitError } = this.props;
    const { showSuccessModal } = this.state;

    if (hasSubmitError) {
      const messageKey = `memberIdentifierRecovery.messages.errors.${submitError.data.error}`;
      return (
        <MessageBox className="alert-danger">
          <FormattedHTMLMessage id={messageKey} />
        </MessageBox>
      );
    }
    return (
      <div>
        <MessageBox className="alert-success">
          <FormattedMessage
            id="memberIdentifierRecovery.messages.success"
            values={{ memberIdentifier }}
          />
        </MessageBox>
        <BSModal
          title={
            <FormattedMessage id="memberIdentifierRecovery.messages.successModalTitle" />
          }
          closeButtonKey="common.ok"
          onClose={this.closeSuccessModal}
          show={showSuccessModal}
        >
          <FormattedHTMLMessage
            id="memberIdentifierRecovery.messages.successModalBody"
            values={{ memberIdentifier }}
          >
            {(t) => <div dangerouslySetInnerHTML={{ __html: t }} />}
          </FormattedHTMLMessage>
        </BSModal>
      </div>
    );
  }

  closeSuccessModal() {
    this.setState({ showSuccessModal: false });
  }

  updateCaptcha(value) {
    const { changeFieldValue } = this.props;
    changeFieldValue(
      "memberIdentifierRecoveryForm",
      "gRecaptchaResponse",
      value || null
    );
  }

  render() {
    const {
      error = {},
      handleSubmit,
      mustUseInstitutionEmailForRecovery,
      submitComplete,
      submitFailed,
      submitting,
    } = this.props;
    const disableForm = submitting;
    return (
      <form onSubmit={handleSubmit}>
        <Field
          id="lastName"
          name="lastName"
          component={TextInput}
          label={
            <FormattedMessage id="memberIdentifierRecovery.form.lastName" />
          }
          disabled={disableForm}
        />
        <Field
          id="firstName"
          name="firstName"
          component={TextInput}
          label={
            <FormattedMessage id="memberIdentifierRecovery.form.firstName" />
          }
          disabled={disableForm}
        />
        <Field
          id="postalCode"
          name="postalCode"
          maxLength="10"
          component={TextInput}
          label={
            <FormattedMessage id="memberIdentifierRecovery.form.postalCode" />
          }
          disabled={disableForm}
        />
        <Field
          id="birthdate"
          name="birthdate"
          component={DayPicker}
          showClearButton={true}
          label={
            <FormattedMessage id="memberIdentifierRecovery.form.birthdate" />
          }
          disabled={disableForm}
        />
        <Field
          id="phoneNumber"
          name="phoneNumber"
          component={TextInput}
          label={
            <FormattedMessage id="memberIdentifierRecovery.form.phoneNumber" />
          }
          disabled={disableForm}
        />
        <Field
          id="emailAddress"
          name="emailAddress"
          component={TextInput}
          label={
            <FormattedMessage
              id={
                mustUseInstitutionEmailForRecovery
                  ? "memberIdentifierRecovery.form.institutionEmail"
                  : "memberIdentifierRecovery.form.memberEmail"
              }
            />
          }
          disabled={disableForm}
        />
        <div className="section">
          <FormattedMessage id="memberIdentifierRecovery.form.conditions.byRecovering" />
          <Field
            id="condition1"
            name="condition1"
            component={StyledCheckboxInput}
            checkbox={{ value: true }}
            label={
              <FormattedMessage id="memberIdentifierRecovery.form.conditions.condition1" />
            }
            disabled={disableForm}
          />
          <Field
            id="condition2"
            name="condition2"
            component={StyledCheckboxInput}
            checkbox={{ value: true }}
            label={
              <FormattedMessage id="memberIdentifierRecovery.form.conditions.condition2" />
            }
            disabled={disableForm}
          />
          <Field
            id="condition3"
            name="condition3"
            component={StyledCheckboxInput}
            checkbox={{ value: true }}
            label={
              <FormattedMessage id="memberIdentifierRecovery.form.conditions.condition3" />
            }
            disabled={disableForm}
          />
          <Field
            id="condition4"
            name="condition4"
            component={StyledCheckboxInput}
            checkbox={{ value: true }}
            label={
              <FormattedMessage id="memberIdentifierRecovery.form.conditions.condition4" />
            }
            disabled={disableForm}
          />
        </div>
        <div className="section">
          <Recaptcha
            ref={(ref) => (this.recaptchaRef = ref)}
            sitekey={config.recaptchaApiKey}
            render="explicit"
            expiredCallback={this.updateCaptcha}
            verifyCallback={this.updateCaptcha}
            onloadCallback={() => {
              /*will not load if this is not defined*/
            }}
          />
          {error.gRecaptchaResponse && submitFailed && (
            <MessageBox className="alert-danger simple">
              <FormattedMessage id={error.gRecaptchaResponse.messageKey} />
            </MessageBox>
          )}
          <Field name="gRecaptchaResponse" component={() => <span />} />
        </div>
        <div className="section">
          <button
            type="submit"
            className="btn btn-lg btn-primary"
            disabled={disableForm}
          >
            <FormattedMessage id="withdrawal.form.submit" />
          </button>
          {submitting && <span className="loader" />}
        </div>

        {submitComplete && this.renderSubmitMessage()}
      </form>
    );
  }
}

MemberIdentifierRecoveryForm.propTypes = {
  changeFieldValue: PropTypes.func,
  error: PropTypes.object,
  handleSubmit: PropTypes.func,
  hasSubmitError: PropTypes.bool,
  memberIdentifier: PropTypes.string,
  mustUseInstitutionEmailForRecovery: PropTypes.bool,
  submitFailed: PropTypes.bool,
  submitComplete: PropTypes.bool,
  submitError: PropTypes.object,
  submitting: PropTypes.bool,
};

function mapStateToProps(state) {
  const recovering = state.memberIdentifierRecovery.recovering || {};

  return {
    hasSubmitError: !!recovering.error,
    memberIdentifier:
      (recovering.data && recovering.data.memberIdentifier) || "",
    submitComplete: !!recovering.completed,
    submitError: recovering.error || {},
    submitting: !!recovering.submitting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "memberIdentifierRecoveryForm",
    validate: (values) =>
      validationUtils.validate(
        values,
        MEMBER_IDENTIFIER_RECOVERY_VALIDATION_RULES
      ),
  })(MemberIdentifierRecoveryForm)
);



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/MemberIdentifierRecoveryForm.js